/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_No_DataInputs */

const vi_report_debt_no_data = /** @type {(inputs: Report_Debt_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có công nợ`)
};

/**

* @param {Report_Debt_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_no_data = /** @type {((inputs?: Report_Debt_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_no_data(inputs)
});